import type { ComponentProps } from 'react';

import type { sliceMap } from './index';

export const enum LayoutType {
  VerticalSpacing = 'vertical_spacing',
}

type SliceComponent = keyof typeof sliceMap;
type SliceComponentProps = ComponentProps<(typeof sliceMap)[SliceComponent]>;

export type Slices = Array<
  | {
      corgiType: string;
      props: SliceComponentProps;
    }
  | {
      layoutType: LayoutType;
    }
>;
